<template>
    <button v-if="!showResult" class="btn --primary mt-auto" @click="checkResponse" :disabled="!odpoved.input">
        skontrolovať<span class="icon icon--check ml-10"></span>
    </button>
    <button v-else class="btn --primary mt-auto" @click="next">
        pokračovať<span class="icon icon--arrow-right ml-10"></span>
    </button>
</template>

<script>

export default {
    components: {},
    props: [
        'showResult',
        'odpoved'
    ],
    data() {
        return {}
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        checkResponse() {
            this.$emit('checkResponse')
        },
        next() {
            this.$emit('next', this.odpoved)
        }
    }
}
</script>
